<template>
  <v-card>
    <validation-observer v-slot="{valid}">
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{ $t('register.title') }}</span>
        <v-avatar
            color="primary"
            class="subheading white--text"
            size="40">
          <v-icon dark>
            mdi-account-plus
          </v-icon>
        </v-avatar>
      </v-card-title>

      <v-window v-model="step">

        <v-window-item :value="1">

          <validation-observer v-if="step===1">

            <v-card-text>
              <validation-provider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email">
                <v-text-field
                    v-bind:label="$t('login.email_input')"
                    v-model="email"
                    :error-messages="errors"
                    required
                    v-on:keyup.enter="handleSteps(valid)"
                ></v-text-field>
              </validation-provider>
              <span class="grey--text text--darken-1">
                {{ $t('register.message_valid_email_address') }}
                </span>
              <br>
              <span class="red--text text--darken-1">
                {{ error_message }}
              </span>
            </v-card-text>
          </validation-observer>

        </v-window-item>


        <v-window-item :value="2">
          <validation-observer v-if="step===2">

            <v-card-text>
              <validation-provider
                  v-slot="{ errors }"
                  name="code"
                  rules="required">
                <v-text-field
                    type="digit"
                    v-bind:label="$t('token_login.validate_code_button')"
                    v-model="code"
                    :error-messages="errors"
                    required
                    v-on:keyup.enter="handleSteps(valid)"
                />
              </validation-provider>

              <span class="grey--text text--darken-1">
                 {{ $t('token_login.span_field_verification_code') }}
               </span>
              <br>
              <span class="red--text text--darken-1" v-bind="error_message">
                 {{ error_message }}
                </span>
            </v-card-text>
          </validation-observer>

        </v-window-item>
        <v-window-item :value="3">
          <validation-observer v-if="step===3">

            <v-card-text>

              <!--      Email         -->
              <validation-provider
                  v-slot="{ errors }"
                  name="code"
                  rules="required">
                <v-text-field
                    type="digit"
                    v-bind:label="$t('login.email_input')"
                    v-model="email"
                    :error-messages="errors"
                    required
                    :disabled="true"
                />
              </validation-provider>

              <!--      First name        -->
              <validation-provider
                  v-slot="{ errors }"
                  rules="required">
                <v-text-field
                    v-bind:label="$t('register.first_name_text_field')"
                    v-model="first_name"
                    :error-messages="errors"
                />
              </validation-provider>

              <!--      last name        -->
              <validation-provider
                  v-slot="{ errors }"
                  rules="required">
                <v-text-field
                    v-bind:label="$t('register.last_name_text_field')"
                    v-model="last_name"
                    :error-messages="errors"
                />
              </validation-provider>

              <!--      Gender        -->
              <validation-provider
                  v-slot="{ errors }"
                  rules="required"
              >
                <v-select
                    required
                    v-model="gender"
                    v-bind:label="$t('profile.gender')"
                    :items="genders"
                    item-value="value"
                    item-text="name"
                    :error-messages="errors"
                />
              </validation-provider>


              <!--      country        -->
              <validation-provider
                  v-slot="{ errors }"
                  rules="required">
                <v-text-field
                    v-bind:label="$t('register.country')"
                    v-model="country"
                    :error-messages="errors"
                />
              </validation-provider>


              <!--      phone        -->
              <validation-provider
                  v-slot="{ errors }"
                  rules="required">
                <v-text-field
                    v-bind:label="$t('login.phone_number_input')"
                    v-model="phone"
                    :error-messages="errors"
                />
              </validation-provider>

              <!--      Password        -->
              <validation-provider
                  v-slot="{ errors }"
                  name="pass"
                  vid="pass"
                  rules="required">
                <v-text-field
                    v-bind:label="$t('register.password_field')"
                    v-model="pass"
                    type="password"
                    :error-messages="errors"
                    required
                />
              </validation-provider>

              <!--      RePassword        -->
              <validation-provider
                  v-slot="{ errors }"
                  name="repass"
                  rules="required|is:@pass">
                <v-text-field
                    v-bind:label="$t('register.password_repeat_field')"
                    type="password"
                    v-model="repass"
                    :error-messages="errors"
                    required
                    v-on:keyup.enter="handleSteps(valid)"
                />
              </validation-provider>

              <!--      Date Picker        -->


              <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                  >

                    <v-text-field
                        v-model="birthday"
                        label="Birthday date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                        :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker
                    v-model="birthday"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                ></v-date-picker>
              </v-menu>

              <span class="grey--text text--darken-1">
                {{ $t('register.complete_section') }}
               </span>
              <br>
              <span class="red--text text--darken-1" v-bind="error_message">
                 {{ error_message }}
                </span>
            </v-card-text>
          </validation-observer>

        </v-window-item>


      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
            v-if="step===2"
            text
            @click="step--"
            v-bind="back_text"
            class="no-spacing"
        >
          {{ back_text }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-progress-circular
            indeterminate
            color="primary"
            v-if="is_loading">
        </v-progress-circular>
        <v-btn
            v-else
            :disabled="!valid"
            color="primary"
            depressed
            type="submit"
            @click="handleSteps"
            v-bind="next_text">
          {{ next_text }}
        </v-btn>
      </v-card-actions>
    </validation-observer>


  </v-card>
</template>

<script>
import {ValidationObserver, ValidationProvider, setInteractionMode, extend} from 'vee-validate';
import {required, is, email} from 'vee-validate/dist/rules'
import axios from "axios";
import FormData from "form-data";
import i18n from "../i18n";


setInteractionMode('eager');
extend('required', {
  ...required,
  message: () => i18n.t('login.required')
})
extend('is', {
  ...is,
  message: () => i18n.t('register.match_password')
})
extend('email', {
  ...email,
  message: () => i18n.t('login.phone_number_format_error')
})


export default {
  name: "login",
  data: () => ({
    step: 1,
    code: '',
    loading: false,
    error_message: '',
    connection: null,
    email: "",
    pass: '',
    repass: '',
    first_name: '',
    last_name: '',
    gender: '',
    country: '',
    phone: '',
    birthday: null,
    menu: false,
  }),

  methods: {
    login_error_handler(err) {
      let error_message = ''
      if (err.response) {
        switch (err.response.status) {
          case 400:
            error_message = i18n.t('register.data_sending_error')
            break;
          case 409:
            error_message = i18n.t('register.duplicate_user_error')
            break;
          default:
            error_message = i18n.t('register.data_sending_error')

        }
      } else {
        error_message = i18n.t('register.data_sending_error')
      }
      return error_message
    },
    check_error_handler(err) {
      let error_message = ''
      if (err.response) {
        switch (err.response.status) {
          case 400:
            if (err.response.data.message === "time limit error") {
              this.step = 2
              error_message = i18n.t('register.time_limit_error')
            } else {
              error_message = i18n.t('register.data_sending_error')
            }
            break;
            case 403:
              error_message = i18n.t('register.wrong_code_error')
              break;
        }
      } else {
        error_message = i18n.t('register.data_sending_error')
      }
      return error_message
    },
    send_verification_request() {
      let data = new FormData();
      data.append('email', this.email);
      this.loading = true
      let config = {
        method: 'post',
        url: this.$store.state.base_url + '/auth/register/verification',
        data: data
      };
      return axios(config)
      },
    send_check_request() {
      let data = new FormData();
      data.append('email', this.email);
      data.append('code', this.code);
      this.loading = true
      let config = {
        method: 'post',
        url: this.$store.state.base_url + '/auth/register/verification/check',
        data: data
      };
      return axios(config)
    },
    send_register_request() {
      let data = new FormData();
      data.append('first_name', this.first_name);
      data.append('last_name', this.last_name);
      data.append('gender', this.gender);
      data.append('email', this.email);
      data.append('password', this.repass);
      data.append('country', this.country);
      data.append('birthday', this.birthday);
      data.append('phone', this.phone);
      this.loading = true
      let config = {
        method: 'post',
        url: this.$store.state.base_url + '/auth/register/',
        data: data
      };
      return axios(config)
    },
    handleSteps(valid) {
      console.log(valid)
      if (valid)
        if (this.step === 1) {
          this.send_verification_request().then(() => {
            this.loading = false
            this.step += 1
            this.error_message = ''
          }).catch((err) => {
            // if err.status
            this.loading = false
            this.error_message = this.login_error_handler(err)
          })
        } else if (this.step === 2) {
          this.send_check_request().then(() => {
            this.loading = false
            this.step += 1
            this.error_message = ''
          }).catch((err) => {
            this.loading = false
            this.error_message = this.check_error_handler(err)
          })
        } else if (this.step === 3) {
          this.send_register_request().then((res) => {
            localStorage.setItem('token', res.data.token)
            this.loading = false
            this.$router.push('/' + this.$route.params.lang)
          }).catch((err) => {
            this.loading = false
            this.error_message = this.check_error_handler(err)
          })
        }
    }
  },


  computed: {
    is_loading() {
      return this.loading
    },
    genders: function () {
      return i18n.t("stepper.static.genders");
    },
    next_text() {
      if (this.step === 2) {
        return i18n.t('token_login.validate_code_button')
      } else if (this.step === 3) {
        return i18n.t('register.submit_information')
      } else {
        return i18n.t('token_login.next_button')
      }
    },
    back_text() {
      return this.step === 1 ? '' : i18n.t('token_login.change_number_button')
    },


  },
  components: {
    ValidationProvider,
    ValidationObserver,
  }

}
</script>

